import { MdMms } from 'react-icons/md';

import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { breakpoints, WEDO_DEFAULT_WIDTH } from '~/styles/breakpoints';
import colors from '~/styles/colors';

export const CardContainer = styled.ul`
  width: ${WEDO_DEFAULT_WIDTH};
  display: flex;
  column-gap: 25px;
  row-gap: 32px;
  flex-wrap: wrap;
  flex-grow: 1;
  box-sizing: inherit;
  width: 100%;

  & > div {
    max-width: 225px;
    min-width: 130px;
    min-height: 149px;
    width: 221px;
    height: 149px;
  }

  @media (max-width: ${breakpoints.sm}) {
    margin-left: 26px;
  }

  @media (max-width: ${breakpoints.xs}) {
    justify-content: center;
  } ;
`;

export const Container = styled.div`
  ${CardContainer}:first-of-type {
    margin-bottom: 64px;
  }
`;

export const ContainerTitle = styled.h1`
  margin-top: 32px;
  margin-bottom: 24px;
  font-weight: normal;
  font-size: 20px;
  color: #4d4d4d;

  @media (max-width: ${breakpoints.sm}) {
    margin-left: 26px;
  }

  @media (max-width: ${breakpoints.xs}) {
    display: flex;
    justify-content: center;
  }
`;

export const ProcessFlowButton = styled(MdMms)`
  cursor: pointer;

  &:hover {
    color: ${colors.primary};
  }
`;

const useStyles = makeStyles({
  palette: {
    primary: {
      main: '#eb0045',
    },
  },
  root: {
    marginLeft: 15,
    marginBottom: 15,
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 15,
  },
  area: {
    minWidth: 130,
    maxWidth: 170,
    minHeight: 175,
  },
  content: {
    padding: 10,
    minHeight: 120,
    maxHeight: 120,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content2: {
    padding: 10,
  },
  version: {
    fontSize: 12,
    // paddingLeft: 4,
    // minWidth: 60,
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: 16,
    color: '#eb0045',
    textAlign: 'center',
  },
  submit: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: 12,
  },
});

export const CloseButtonModal = styled.button`
  border: 0;
  background: none;
  align-self: flex-end;

  svg {
    fill: ${colors.gray};
  }
`;

export const ModalTitle = styled.h1`
  font-size: 24px;
  color: #4d4d4d;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
    margin: 16px 0 26px 0;
  }
`;

export default useStyles;
